import { createSelector } from 'reselect'

const selector = state => state.paymentReducer

export const paymentsLoadSelector = createSelector(
  [selector],
  ({ filters }) => filters
)

export const paymentsIvoicesSelector = createSelector(
  [selector],
  ({ payments }) => payments
)

export const paymentsLoadPageSelector = createSelector(
  [selector],
  ({ loadPage }) => loadPage
)

export const paymentsErrorSelector = createSelector(
  [selector],
  ({ error }) => error
)

export const payoutTermsSelector = createSelector(
  [selector],
  ({ payoutTermsTypes }) => payoutTermsTypes
)

export const paymentsSelector = createSelector(
  [selector],
  payments => payments
)
